const ADDRESS_NOT_VALID = 'Address is not valid'
const CHANGE_ADDRESS = 'Try to change your address!'
const CLOSE = 'Close'
const SUGGESTIONS = 'Address Suggestion'
const ACCEPT = 'Accept'
const OK = 'Ok'

export { ADDRESS_NOT_VALID, CHANGE_ADDRESS, CLOSE, SUGGESTIONS, ACCEPT, OK }
